import gql from 'graphql-tag';

export default gql`
    mutation ResolveAllDriverLoadNotes($input: ResolveAllDriverLoadNotesInput) {
        resolveAllDriverLoadNotes(input: $input) {
            errors
        }
    }
`;
